import { collection, or, and, where, orderBy } from 'firebase/firestore';
import { eduDb } from '@/firebase';
import { useAuthStore } from '@/v2/store/shared/auth-store';
import { Registration } from '../../entities/registration';
import { useFirebaseTableStore } from '@/v2/store/shared/firebase-table-store';
import { registrationStatusEnum } from '../../entities/registration';

const filtersBuilderFunction = (filters) => {
	const queryData = [];
	const filtersArray = [];

	queryData.push(orderBy('createdAt', 'desc'));

	if (filters.gender) {
		filtersArray.push(where('gender', '==', filters.gender));
	} else {
		filtersArray.push(where('gender', 'in', ['Male', 'Female', 'empty']));
	}

	if (filters.status) {
		filtersArray.push(where('status', '==', filters.status));
	} else {
		filtersArray.push(where('status', 'in', Object.values(registrationStatusEnum)));
	}

	if (filters.createdAt?.from) {
		const milliseconds = new Date(filters.createdAt?.from).getTime();
		filtersArray.push(where('createdAt', '>=', milliseconds));
	} else {
		filtersArray.push(where('createdAt', '>=', 0));
	}

	if (filters.createdAt?.to) {
		const milliseconds = new Date(filters.createdAt?.to).getTime();
		filtersArray.push(where('createdAt', '<=', milliseconds));
	} else {
		const now = new Date().getTime() + 1000 * 60 * 60 * 24 * 10;
		filtersArray.push(where('createdAt', '<=', now));
	}

	if (filters.search) {
		filtersArray.push(
			and(
				or(
					and(
						where('studentName', '>=', filters.search),
						where('studentName', '<=', filters.search + '\uf8ff'),
					),
					and(
						where('email', '>=', filters.search),
						where('email', '<=', filters.search + '\uf8ff'),
					),
				),
			),
		);
	} else {
		filtersArray.push(
			and(
				or(
					and(where('studentName', '>=', ''), where('studentName', '<=', '' + '\uf8ff')),
					and(where('email', '>=', ''), where('email', '<=', '' + '\uf8ff')),
				),
			),
		);
	}

	if (filters.learningPathName) {
		filtersArray.push(where('learningPath.learningPathName', '==', filters.learningPathName));
	}

	// console.log({ queryData });

	queryData.push(and(...filtersArray));

	return queryData;
};

export const getRegistrationTableStore = () => {
	const authStore = useAuthStore();

	const dataCollection = collection(eduDb, `tenants/${authStore.tenantId}/registrations`);
	const tableStore = useFirebaseTableStore({
		tableName: 'registrationResponses',
		collection: dataCollection,
		filtersBuilderFunction,
		documentMappingFunction: (doc) => {
			return new Registration({ ...doc.data(), id: doc.id });
		},
		realtime: true,
	});

	return tableStore;
};
